import React from 'react';
import '../pages/ServiceSection.css';

const services = [
  {
    icon: '🤖',
    title: 'AI Chatbots & Virtual Assistants',
    desc: '24/7 digital agents to automate, qualify and support real business growth.'
  },
  {
    icon: '🔗',
    title: 'API Integration & Automation',
    desc: 'Seamless data flows and automation — powering tomorrow’s digital businesses.'
  },
  {
    icon: '🧩',
    title: 'ERP & CRM Solutions',
    desc: 'Centralize operations and unlock smarter decisions with tailored software.'
  },
  {
    icon: '🎨',
    title: 'UI/UX Design & Prototyping',
    desc: 'Standout, human-centered design for delightful digital experiences.'
  },
  {
    icon: '⚙️',
    title: 'Custom Software & SaaS Solutions',
    desc: 'From MVPs to scalable SaaS, tech that helps you leap ahead.'
  },
  {
    icon: '📱',
    title: 'Mobile App Development',
    desc: 'Powerful apps, beautiful UI, frictionless journeys on every device.'
  }
];

const Services: React.FC = () => (
  <section className="services-section premium-services" style={{minHeight: '78vh'}}>
    <h2 className="services-title gradient-text">Our Services</h2>
    <div className="services-grid premium-grid">
      {services.map((service, idx) => (
        <div className="service-card premium-card" key={idx}>
          <div className="service-icon-glass">{service.icon}</div>
          <h3>{service.title}</h3>
          <p>{service.desc}</p>
        </div>
      ))}
    </div>
  </section>
);
export default Services;
